// Customer portal client (user, 2026-11-05). Its own axios instance and its
// own token, kept apart from the staff app: the staff instance logs out and
// redirects to the staff login on a 401, which is wrong for a customer.
import axios from "axios";

const portalApi = axios.create({ baseURL: process.env.REACT_APP_API_URI });

const tokenKey = (companyId) => `portal-token:${companyId}`;

export const getPortalToken = (companyId) => {
  try {
    return localStorage.getItem(tokenKey(companyId));
  } catch {
    return null;
  }
};

export const setPortalToken = (companyId, token) => {
  try {
    if (token) localStorage.setItem(tokenKey(companyId), token);
    else localStorage.removeItem(tokenKey(companyId));
  } catch {
    /* private window: nothing to keep */
  }
};

export const portalHeaders = (companyId) => ({
  "x-portal-token": getPortalToken(companyId) || "",
});

export const errMessage = (err, fallback = "Something went wrong") =>
  err?.response?.data?.message || err?.message || fallback;

// On portal.orderrun.com the company id is the first path part (/12/login);
// on the main site the portal lives under /portal/12/login.
export const isPortalHost = () => /^portal\./i.test(window.location.hostname);

export const portalPath = (companyId, page = "") => {
  const base = isPortalHost() ? `/${companyId}` : `/portal/${companyId}`;
  return page ? `${base}/${page}` : base;
};

// The link staff give a customer. REACT_APP_PORTAL_URL is set once
// portal.orderrun.com points at this app; until then the link uses the
// address staff are on, e.g. https://orderrun.com/portal/12/login.
export const portalLoginUrl = (companyId) => {
  const portalBase = (process.env.REACT_APP_PORTAL_URL || "").replace(/\/+$/, "");
  return portalBase
    ? `${portalBase}/${companyId}/login`
    : `${window.location.origin}/portal/${companyId}/login`;
};

export default portalApi;
